import { createReducer } from "redux-create-reducer";
import {
  CLEAR_SCORE_CARDS_BY_TYPE,
  GET_SCORE_CARDS_BY_TYPE,
} from "../types/getScoreCardsByTypeTypes";
const initialState = {
  clientTypes: [],
};

const getScoreCardsByTypeReducer = createReducer(initialState, {
  [GET_SCORE_CARDS_BY_TYPE.DEFAULT]: (state) => ({
    ...state,
  }),
  [GET_SCORE_CARDS_BY_TYPE.PENDING]: (state) => ({
    ...state,
  }),
  [GET_SCORE_CARDS_BY_TYPE.REJECTED]: (state) => ({
    ...state,
  }),
  [GET_SCORE_CARDS_BY_TYPE.FULFILLED]: (state, { payload }) => {
    let data = payload.data.map(function (d) {
      return {
        value: d.targetType,
        label: d.targetType,
        category: d.targetTypeCategory,
        targetTypeCategory: d.targetTypeCategory,
      };
    });
    return {
      ...state,
      clientTypes: [...data],
    };
  },
  [CLEAR_SCORE_CARDS_BY_TYPE]: () => initialState,
});

export default getScoreCardsByTypeReducer;



// WEBPACK FOOTER //
// ./src/reducers/getScoreCardsByTypeReducer.js